import HttpClient from "./http-client";

export interface IDatabaseData {
  id: string; // Connection Id
  database_name: string; // Database engine name
  db_backup_master_id?: string; // Backup master Id
  schema_name?: string;
  table_name?: string;
  regex_for_db?: string;
  regex_for_schema?: string;
  regex_for_table?: string;
  s3_url?: string;
}

export default class DatabaseAPIServices {
  public static async getDatabaseList(payload: IDatabaseData) {
    try {
      const { data } = await HttpClient.post(`db/db_list/`, payload);
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

  public static async getSchemaList(payload: IDatabaseData) {
    try {
      const { data } = await HttpClient.post(`db/db_schema_list/`, payload);
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

  public static async getTableList(payload: IDatabaseData) {
    try {
      const { data } = await HttpClient.post(`db/db_schema_table_list/`, payload);
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

  public static async getS3BucketList() {
    const { data } = await HttpClient.get(`s3/`);
    return data.data;
  }

  public static async createBackupDBDetails(payload: any) {
    try {
      const { data } = await HttpClient.post(`db/backup/backup_db_details/`, payload);
      if (data.status !== undefined)
        return {"status": data.status, "db_backup_master_id": data.db_backup_master_id, "message": data.message};
      
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

}
